






import { Component, Vue } from "vue-property-decorator";
import HhSurveilansList from "@/components/ppi/hh-surveilans/HhSurveilansList.vue";

@Component({
  components: { HhSurveilansList }
})
export default class HhSurveilansPage extends Vue {}
